<template>
  <Modal
    v-model="show"
    width="500"
    footer-hide
    :closable="false"
  >
    <div class="loading-title">提示</div>
    <div class="loading-content">
      <Icon :type="iconShow.icon" :color="iconShow.color" size="80"></Icon>
      <span class="loading-text">{{ modalText }}</span>
      <Button type="primary" @click="close">关闭</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  props: {
    modalType: {
      type: Number,
      default: 0 // 1:成功 -1:失败
    },
    modalText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false,
      successIcon: 'ios-checkmark-circle',
      failIcon: 'ios-close-circle'
    };
  },
  computed: {
    iconShow() {
      let info = {
        icon: '',
        color: ''
      };
      switch (this.modalType) {
        case 1:
          info = {
            icon: this.successIcon,
            color: 'rgb(39, 211, 53)'
          };
          break;
        case -1:
          info = {
            icon: this.failIcon,
            color: 'rgb(222, 55, 36)'
          };
          break;
        default:
          break;
      }
      return info;
    }
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    }
  }
};
</script>
<style scoped>
.loading-title{
  color: #333;
  font-size: 16px;
  font-weight: 600;
}
.loading-text{
  color: #333;
  font-weight: 600;
  font-size: 24px;
  margin-top: 24px;
  margin-bottom: 24px;
}
.loading-content{
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
